import { DiscordIcon } from './Discord.icon';
import { QuickchatAiIcon } from './QuickchatAiWordmark.icon';
import { cn } from '@/Domain/utils/cn';

/**
 * "Quickchat AI for Discord" lockup — the Quickchat wordmark + "for" + the Discord
 * mark. Pinned to the on-surface light color so it reads on the Discord deep-space
 * background.
 */
export const QuickchatForDiscordLockup = ({
  className,
  label = 'Quickchat AI for Discord',
}: {
  className?: string;
  label?: string;
}) => (
  <div
    role="img"
    aria-label={label}
    className={cn(
      'flex items-center gap-2.5 text-[var(--qc-discord-on-surface,#f2f3f5)]',
      className,
    )}
  >
    {/* Cropped to the wordmark's ink box; width/height must track it, since the intrinsic aspect ratio comes from those attributes rather than the viewBox. */}
    <QuickchatAiIcon
      viewBox="12 6.7 101.1 16.7"
      width={101.1}
      height={16.7}
      className="h-5 w-auto"
      aria-hidden
    />
    {/* Matches the marketing nav lockup: a quiet connector, not a peer of the two brand marks. */}
    <span className="text-[var(--qc-discord-muted,#b5bac1)] text-sm font-semibold leading-none">
      for
    </span>
    <span className="flex items-center gap-1.5">
      <DiscordIcon className="h-5 w-auto" style={{ fill: 'currentColor' }} aria-hidden />
      <span className="text-lg font-semibold tracking-tight leading-none">Discord</span>
    </span>
  </div>
);
